var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 217,
    viewBox: "0 0 200 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#E5F9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3326 86.666C27.5698 86.666 18 96.2361 18 107.999V110.811L31.509 123.707L18 135.705V176.36C18 188.123 27.5698 197.693 39.3326 197.693H101.318L112.004 150.16L101.318 86.6664H39.3326V86.666Z",
    fill: "#51C77C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.299 86.666H101.318V197.693H163.303C175.066 197.693 184.636 188.123 184.636 176.36V121.866L124.299 86.666Z",
    fill: "#53B175"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.956 168.576H144.224V178.952H109.956V168.576Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.424 168.576H166.93V178.952H155.424V168.576Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0675 182.139C39.2507 182.139 32.0781 174.966 32.0781 166.149C32.0781 157.333 39.2507 150.16 48.0675 150.16C56.8843 150.16 64.057 157.333 64.057 166.149C64.057 174.966 56.8843 182.139 48.0675 182.139Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 110.811V135.706H101.318L108.173 123.707L101.318 110.811H18Z",
    fill: "#444444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.318 110.811H155.401V135.706H101.318V110.811Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.601 97.5059C118.601 118.569 135.737 135.705 156.801 135.705L164.013 98.2637L156.801 59.3064C135.737 59.3064 118.601 76.4426 118.601 97.5059Z",
    fill: "#FFC648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.801 59.3064V135.705C177.864 135.705 195 118.569 195 97.5059C195 76.4426 177.864 59.3064 156.801 59.3064Z",
    fill: "#E69E00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.615 73.9268V99.9489H156.801L159.395 86.9376L156.801 73.9268H151.615Z",
    fill: "#EDF5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.615 113.886C151.741 116.696 153.893 119.072 156.801 119.072L158.681 113.836L156.801 108.7C154.088 108.7 151.489 111.085 151.615 113.886Z",
    fill: "#EDF5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.801 73.9268H161.986V99.9489H156.801V73.9268Z",
    fill: "#D6E8FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.986 113.886C161.86 111.076 159.708 108.7 156.801 108.7V119.072C159.513 119.072 162.112 116.686 161.986 113.886Z",
    fill: "#D6E8FD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsuccessIcon);
export default __webpack_public_path__ + "static/media/unsuccess-icon.0f4bfefdf6a82e4fe78c7ffc8190e72f.svg";
export { ForwardRef as ReactComponent };